import React, {useState} from 'react';
import {
    Box,
    Collapse,
    IconButton,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    Typography,
} from '@material-ui/core';
import useStyles from '../../styles/styles';
import setDate from "../../utils/setDate";
import KeyboardArrowRightIcon from '@material-ui/icons/KeyboardArrowRight';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';

const SignatureBlocksTable = ({id, signatureBlockActions = []}) => {
    const classes = useStyles();

    function Row(blockAction) {

        return (
            <TableRow key={blockAction.id} id={blockAction.id}>
                <TableCell variant="body">{blockAction.signatureBlock.blockReason}</TableCell>
                <TableCell variant="body">{blockAction.signatureBlock.filterField}</TableCell>
                <TableCell variant="body">{blockAction.signatureBlock.blockValue}</TableCell>
                <TableCell variant="body">{blockAction.blockActionTaken}</TableCell>
                <TableCell
                    variant="body">{setDate(blockAction.signatureBlock.dateCreated)}</TableCell>
                <TableCell variant="body">{setDate(blockAction.signatureBlock.expires)}</TableCell>
            </TableRow>
            )
    }

    return (
        <>
            <Typography variant="h4" component="h4" align="left" id={"signature-block-table"}>
                Signature Block
            </Typography>
            <Paper className={classes.paper}>
                <Table className={classes.table} size="small">
                    <TableHead>
                        <TableRow>
                            <TableCell variant="head">Reason</TableCell>
                            <TableCell variant="head">Filter Field</TableCell>
                            <TableCell variant="head">Value</TableCell>
                            <TableCell variant="head">Action</TableCell>
                            <TableCell variant="head">Created</TableCell>
                            <TableCell variant="head">Expires</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {signatureBlockActions.map(blockAction =>
                            Row(blockAction)
                        )}
                        {!signatureBlockActions.length ? (
                            <TableRow>
                                <TableCell variant="body" colSpan={6}>
                                    No Results
                                </TableCell>
                            </TableRow>
                        ) : null}
                    </TableBody>
                </Table>
            </Paper>
        </>
    );
};

export default SignatureBlocksTable;
